module.exports = __webpack_public_path__ + "img/move-fm.6cd1f6ee.png";